import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';

// Import assets
import './searchForm.scss';
import theme from './searchTheme';

const renderSuggestion = suggestion => (
  <div>
    {suggestion.label}
  </div>
);

const getSuggestionValue = suggestion => suggestion.label;

const renderInputComponent = inputProps => (
  <div className="m-search-form__input">
    <input {...inputProps} />
  </div>
);

const RenderSuggestionsContainer = ({ containerProps, children }) => (
  <div className="m-search-form__suggestions" {...containerProps}>
    {children}
  </div>
);

RenderSuggestionsContainer.propTypes = {
  containerProps: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
};

class SearchForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      usedTags: '',
      suggestions: [],
    };

    this.updateSearchParam = this.updateSearchParam.bind(this);
    this.triggerSearch = this.triggerSearch.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.enter = this.enter.bind(this);
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.visible && !this.props.visible) {
      this.inputShouldFocus = true;
    }
  }

  componentDidUpdate() {
    if (this.inputShouldFocus) {
      this.input.focus();
      this.inputShouldFocus = false;
    }
  }

  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }

  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
    });
  }

  onSuggestionSelected(event, { suggestionValue, method }) {
    let newValue = '';
    if (this.state.usedTags) {
      newValue = `${this.state.usedTags} ${suggestionValue}`;
      this.setState({
        usedTags: newValue,
      });
    } else {
      newValue = suggestionValue;
      this.setState({
        usedTags: newValue,
      });
    }

    this.updateSearchParam(event, { newValue, method });
  }

  getAutocompleteOptions() {
    const options = [];
    this.props.categories.map((category) => {
      options.push({
        label: category.title,
      });
      category.items.map((subcategory) => {
        options.push({
          label: subcategory.title,
        });
        return options;
      });
      return options;
    });
    return options;
  }

  getSuggestions(values) {
    const inputValues = values.split(' ');
    const inputLength = inputValues.length;

    const options = this.getAutocompleteOptions();

    let suggestions = [];

    if (inputLength > 0 && options.length > 0) {
      suggestions = options.filter((option) => {
        let include = false;
        if (option.label) {
          for (let i = 0; i < inputValues.length; i += 1) {
            const value = inputValues[i].trim().toLowerCase();
            include = option.label.toLowerCase().slice(0, value.length) === value;
          }
        }

        return include;
      });
    }

    return suggestions;
  }

  triggerSearch() {
    if (this.state.value) {
      this.props.history.push(`/${process.env.LENSPIRE_CHANNEL}/${this.props.lang}/search/${this.state.value}`);
    }
  }

  enter(e) {
    if (e.key.toLowerCase() === 'enter') {
      this.triggerSearch();
    }
  }

  updateSearchParam(event, { newValue }) {
    if ((!this.state.value && this.state.usedTags !== '') || this.state.value.length < this.state.usedTags.length) {
      this.setState({
        usedTags: '',
      });
    }
    this.setState({
      value: newValue,
    });
  }

  render() {
    if (this.props.visible) {
      const { value, suggestions } = this.state;
      const inputProps = {
        placeholder: this.props.t('translations.Search Lenspire'),
        value,
        onChange: this.updateSearchParam,
        type: 'search',
        onKeyPress: this.enter,
      };

      return (
        <div className="m-search-form">
          <Autosuggest
            suggestions={suggestions}
            renderSuggestion={renderSuggestion}
            getSuggestionValue={getSuggestionValue}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            onSuggestionSelected={this.onSuggestionSelected}
            renderInputComponent={renderInputComponent}
            renderSuggestionsContainer={RenderSuggestionsContainer}
            inputProps={inputProps}
            theme={theme}
            onChange={this.enter}
            ref={(autosuggest) => {
              if (autosuggest !== null) {
                this.input = autosuggest.input;
              }
            }}
          />
          <span className="m-search-form__icon" onClick={this.triggerSearch} role="button" tabIndex={-1}>
            <svg>
              <use xlinkHref={'#Lenspire_Icon_Search'} />
            </svg>
          </span>
        </div>
      );
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    categories: state.navState['main-navigation'],
    lang: state.globalsState.lang,
  };
}

SearchForm.propTypes = {
  visible: PropTypes.bool,
  categories: PropTypes.arrayOf(PropTypes.shape()),
  t: PropTypes.func.isRequired,
  lang: PropTypes.string,
  history: PropTypes.shape().isRequired,
};

SearchForm.defaultProps = {
  visible: false,
  categories: [],
  lang: 'en',
};

export default withRouter(connect(mapStateToProps)(translate()(SearchForm)));



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/SearchForm/SearchForm.jsx